import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";
import { ResponsePersonalDto } from '../dto/personal.dto';


@Injectable()
export class PersonalNestApi {

  private service: string = '';
  private model: string = 'personal';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getPersonal(empId: string): Observable<ResponsePersonalDto> {
    const method: string = 'GET';
    const func: string = 'getPersonal';
    const params: any = {};
    const urlParams: any = { empId: empId };
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePersonalDto>(method, url, params, urlParams, body, null, null, null, false);
  }

  public edutitleList(payload?: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'edutitleList';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public edutitle2List(payload?: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'edutitle2List';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public nationalityList(payload?: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'nationalityList';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public salutationList(payload?: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'salutationList';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public religionList(payload?: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'religionList';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public maritalList(payload?: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'maritalList';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public cityList(payload?: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'cityList';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public dialectList(payload?: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'dialectList';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public raceList(payload?: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'raceList';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/personal.api.ts